import { onMount, onDestroy, onView } from "@/modules/_";
import gsap, { Flip } from "@lib/gsap";
import { Scroll } from "@lib/scroll";
import hey from "@lib/hey";

export default function (element: HTMLElement, dataset: any) {
  const gridSections = element.querySelectorAll("[data-product-grid]");

  const desktopNavMainGroupItems = document.querySelectorAll(
    "[data-nav-desktop-main-group] [data-nav-item]"
  );

  const menuOpen = document.querySelector("[data-menu-open]");

  const navClip = document.querySelector(".m-nav-inner-clip");

  const navClipWrapper = navClip?.querySelector(".m-nav-items");

  let observer: IntersectionObserver | null = null;

  const flipNavItems = (index: number) => {
    const direction = Scroll.direction;
    const currentItem = desktopNavMainGroupItems[index];

    navClip?.classList.remove("hidden");

    if (direction === 0) {
      gsap.set(menuOpen, {
        y: 0,
      });
      desktopNavMainGroupItems.forEach((item, i) => {
        if (i === index) {
          item.classList.add("scrolled");
          gsap.fromTo(
            item.querySelector(".nav_item_view"),
            {
              opacity: 0,
            },
            {
              opacity: 1,
              duration: 0.5,
              ease: "smooth",
            }
          );
        } else {
          item.classList.remove("scrolled");
        }
      });
      return;
    }

    gsap.to(menuOpen, {
      y: 0,
      ease: "smooth",
    });

    if (direction === 1 && index === 0) {
      gsap.fromTo(
        navClipWrapper,
        {
          y: 21,
        },
        {
          y: 0,
          ease: "smooth",
        }
      );
    } else {
      gsap.to(navClipWrapper, {
        y: index * -21,
        ease: "smooth",
      });
    }

    // if (direction === 1) {
    const previousItem = document.querySelector(
      `[data-nav-desktop-main-group] [data-nav-item].scrolled`
    );

    if (previousItem) {
      const currentItemView = currentItem.querySelector(
        ".nav_item_view"
      ) as HTMLElement;
      const previousItemView = previousItem.querySelector(
        ".nav_item_view"
      ) as HTMLElement;

      currentItemView.dataset.flipId = `${index}-forward`;
      previousItemView.dataset.flipId = `${index}-forward`;

      const state = Flip.getState([previousItemView, currentItemView]);
      currentItem.classList.add("scrolled");
      previousItem.classList.remove("scrolled");

      gsap.set([previousItemView, currentItemView], {
        opacity: 1,
      });

      Flip.from(state, {
        ease: "smooth",
      });
    } else {
      currentItem.classList.add("scrolled");
      gsap.fromTo(
        currentItem.querySelector(".nav_item_view"),
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.5,
          ease: "smooth",
        }
      );
    }
  };

  const mainGroupObserver = onView(element, {
    root: null,
    rootMargin: "0px",
    threshold: 0,
    autoStart: false,
    once: false,
    callback: ({ isIn }) => {
      if (!isIn) {
        desktopNavMainGroupItems.forEach((item) => {
          if (item.classList.contains("scrolled")) {
            gsap.to(item.querySelector(".nav_item_view"), {
              opacity: 0,
              duration: 0.5,
              ease: "smooth",
              onComplete: () => {
                item.classList.remove("scrolled");
              },
            });
          }
        });

        const direction = Scroll.direction;

        if (direction !== 0) {
          gsap.to(menuOpen, {
            // clearProps: "top",
            y: 14,
            ease: "smooth",
          });
        }

        if (direction === 1) {
          gsap.to(navClipWrapper, {
            y: -21 * 5,
            ease: "smooth",
          });
        } else {
          gsap.to(navClipWrapper, {
            y: 21,
            ease: "smooth",
          });
        }
      }
    },
  });

  onMount(() => {
    // observe all gridSections

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const elIndex = Array.from(gridSections).indexOf(
            entry.target as HTMLElement
          );
          flipNavItems(elIndex);
        }
      });
    });

    gridSections.forEach((section) => {
      observer?.observe(section);
    });

    mainGroupObserver.start();
  });

  onDestroy(() => {
    observer?.disconnect();
    observer = null;
    mainGroupObserver.destroy();
  });
}
